import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Defer pixel loading until after page is interactive
    const loadPixel = () => {
      // @ts-ignore
      if (window.fbq) return;
      // @ts-ignore
      const n = window.fbq = function () {
        // @ts-ignore
        n.callMethod ?
        // @ts-ignore
        n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      // @ts-ignore
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
      // @ts-ignore
      fbq('init', '1300381271931772');
      // @ts-ignore
      fbq('track', 'PageView');
    };
    // Use requestIdleCallback if available, otherwise setTimeout
    if ('requestIdleCallback' in window) {
      // @ts-ignore
      window.requestIdleCallback(loadPixel, {
        timeout: 3000
      });
    } else {
      setTimeout(loadPixel, 2000);
    }
  }, []);
  return <noscript data-id="element-4">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1300381271931772&ev=PageView&noscript=1" alt="" data-id="element-5" />
    </noscript>;
}